import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';
import { useDownloadVisitaActaMutation } from '../../../../services/visitasApi';
import { VisitaEstado } from '../../consts/visitasStatus';
import { buildActaInterviewedData } from '../../utils/actaPayload';
import { CommonMimeType, downloadBase64File } from '../../../../utils/base64FileDownload';

const TIPO_ACTA_VISITA = 1;

// Acta de Visita de una visita de tipo siniestro (SMP-397): se ofrece recien cuando el BO la
// aprobo (PRESENTADO). Es la misma acta que el resto de los tipos de visita; el back le suma los
// datos del siniestro como referencia.
export const useDescargaActaSiniestro = (visita: any) => {
    const { t } = useTranslation('visitas');
    const [downloadVisitaActa] = useDownloadVisitaActaMutation();
    const [descargandoActaSiniestro, setDescargandoActaSiniestro] = useState(false);

    const puedeDescargarActaSiniestro =
        Boolean(visita?.siniestro?.id) && visita?.estado === VisitaEstado.PRESENTADO;

    const descargarActaSiniestro = async () => {
        if (!puedeDescargarActaSiniestro || descargandoActaSiniestro) return;

        setDescargandoActaSiniestro(true);
        try {
            const response = await downloadVisitaActa({
                idVisita: visita.id,
                idTipoVisita: visita.idTipoVisita ?? visita.actividades?.[0]?.tipoVisita?.id,
                tipoActa: TIPO_ACTA_VISITA,
                datos: buildActaInterviewedData(visita)
            }).unwrap();

            // Sin PDF en la respuesta no se descarga nada: ni vacio ni corrompido.
            if (!response?.data) throw new Error('Acta sin contenido');

            downloadBase64File({
                base64Data: response.data,
                fileName: `${t('table.actions.downloadActaFilename')}.pdf`,
                mimeType: CommonMimeType.PDF
            });
        } catch {
            enqueueSnackbar(t('execution.alerts.downloadActaSiniestro.error'), {
                variant: 'error'
            });
        } finally {
            setDescargandoActaSiniestro(false);
        }
    };

    return { puedeDescargarActaSiniestro, descargandoActaSiniestro, descargarActaSiniestro };
};
